/* eslint-disable @typescript-eslint/no-unused-vars */
// src/i18n.js
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import your translation files
import en from '../languages/en.json'
import ro from '../languages/ro.json'

// 1) Custom Logger
// ----------------
const customLogger = {
	// For normal logs
	log: (...msg) => console.log('[i18next-log]', ...msg),
	// For warnings
	warn: (...msg) => console.warn('[i18next-warn]', ...msg),
	// For errors
	error: (...msg) => console.error('[i18next-error]', ...msg)
}

// 2) Monkey-Patch 't' for Try/Catch
// ---------------------------------
const originalT = i18n.t.bind(i18n)
i18n.t = (key, options) => {
	try {
		return originalT(key, options)
	} catch (e) {
		console.error('i18n.t crashed on key:', key, e)
		return key // fallback
	}
}

i18n.on('initialized', () => {
	// console.log('--- Initialized i18n ---')
})
	.on('failedLoading', (lng, ns, msg) =>
		console.error(`failedLoading => [${lng}:${ns}]`, msg)
	)
	.on('missingKey', (lngs, namespace, key) => {
		console.warn(`missingKey => [${lngs}:${namespace}] ${key}`)
	})
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			ro: { translation: ro }
		},
		fallbackLng: 'en',
		debug: false,
		interpolation: { escapeValue: false },
		// 3) Use the custom logger
		// ------------------------
		logger: customLogger,
		// 4) Disable Suspense, so errors are more directly revealed in console:
		// ---------------------------------------------------------------------
		react: { useSuspense: false }
	})

export default i18n
